import FilledSearchTextField from './filled-search-text-field-view'

export default FilledSearchTextField
